import { LinkField, TextField } from "@sitecore-jss/sitecore-jss-nextjs";
import Image from "next/image";
import Link from "next/link";
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import { extractRelativePath } from "components/Shared/DomainSplit";
import { FunctionComponent } from "react";
import IsRtl from "components/Shared/isRtl";
import { getDgAButtonClassNames } from "components/Shared/dga-button/DGAButton";

export type SocialMediaItemFields = {
  Icon?: {
    value: {
      src: string;
      alt: string;
    };
  };
  PlatformUrl?: LinkField;
  PlatformTitle?: TextField;
};

export const SocialMediaCard: FunctionComponent<SocialMediaItemFields> = ({
  Icon,
  PlatformTitle,
  PlatformUrl,
}) => {
  const href = PlatformUrl?.value?.href ?? "#";
  const isDisabled = !PlatformUrl?.value?.href;
  return (
    <div className="p-4 border border-neutral-300 rounded-2xl flex flex-col gap-4 animate-top-dga">
      {Icon?.value?.src && (
        <div className="relative w-[48px] h-[48px] rounded-full">
          <Image
            src={extractRelativePath(Icon?.value?.src)}
            alt={Icon?.value?.alt || "Social media icon"}
            layout="fill"
            className="object-contain w-full h-full"
          />
        </div>
      )}
      {PlatformTitle?.value && <p className="text-lg font-bold">{PlatformTitle.value}</p>}
      <Link href={href} passHref>
        <a
          target={PlatformUrl?.value?.target || "_self"}
          rel={PlatformUrl?.value?.target === "_blank" ? "noopener noreferrer" : undefined}
          className={`self-end inline-flex items-center justify-center ${getDgAButtonClassNames(
            "secondarySolid",
            "lg",
            `${IsRtl() ? "rotate-180" : ""} ${isDisabled ? "opacity-50 pointer-events-none" : ""}`
          )}`}
          aria-label={
            PlatformTitle?.value
              ? `Open ${PlatformTitle.value} profile`
              : "Open social media link"
          }
        >
          <ArrowRightIcon width={24} height={24} aria-hidden={true} />
        </a>
      </Link>
    </div>
  );
};
